import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CustomExpansionPanel from '../CustomizedComponents/CustomExpansionPanel';
import BasicInformation from './BasicInformation/BasicInformation';
import PurchaseStep from './PurchaseStep/PurchaseStep';
import Volume from './Volumes/Volume';
import NoData from '../CustomizedComponents/DisplayData/NoData';
import { FormattedMessage } from 'react-intl';
import useAppContext from '../../hooks/context/useAppContext';
import CustomSnackBar from '../CustomizedComponents/CustomSnackbar';
import styled from 'styled-components';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import { useIntl } from 'react-intl';
import PriceCoefficient from './PriceCoefficient/PriceCoefficient';

const LoadingWrapper = styled.div`
  height: 2px;
`;

const TransactionWrapper = ({ transaction, loading, error, handlers, isNew }) => {
  const { customerEnumLoading, productEnumLoading, contractLoading, contractsEnumLoading } = transaction;
  const shouldDisplay = !customerEnumLoading && !productEnumLoading && !contractLoading && !contractsEnumLoading;

  const noData = 'app.dataTable.body.noData';
  const showNothingToDisplay = Object.keys(transaction).length === 0 && !loading && !error;
  const showError = !!error;
  const showBody = (transaction && !error && !loading && shouldDisplay) || (isNew && !loading && shouldDisplay);

  return (
    <>
      {showNothingToDisplay && (
        <NoData>
          <FormattedMessage id={noData} />
        </NoData>
      )}
      {showError && (
        <NoData>
          <FormattedMessage id={noData} />
        </NoData>
      )}
      {!showBody && (
        <LoadingWrapper>
          <LoadingIndicator />
        </LoadingWrapper>
      )}

      {showBody && <TransactionBody isNew={isNew} transaction={transaction} handlers={handlers} loading={loading} />}
    </>
  );
};

TransactionWrapper.propTypes = {
  isNew: PropTypes.any,
  transaction: PropTypes.object,
  loading: PropTypes.any,
  error: PropTypes.any,
  handlers: PropTypes.object,
};

const TransactionBody = ({ transaction, handlers, isNew, loading }) => {
  const intl = useIntl();
  const [activePannelId, setActivePannelId] = useState(1);
  const [editable, setEditable] = useState(true);
  const success = intl.formatMessage({ id: 'app.action.saved' });
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(success);
  const [issues, setIssues] = useState(null);
  const [expandedState, setExpandedState] = useState(false);

  const changePannel = (changeId) => {
    setActivePannelId(activePannelId === changeId ? 0 : changeId);
  };
  const { getEnums, setBackNavigation } = useAppContext();
  const enums = getEnums();

  const { postLoading, putLoading, postError, putError } = transaction;

  const loaders = [postLoading, putLoading];

  const { setIsNew } = handlers;

  useEffect(() => {
    if (isNew) {
      setEditable(true);
    }
  }, [isNew]);
  useEffect(() => {
    setBackNavigation('/transactions');
  }, [setBackNavigation]);

  useEffect(() => {
    if (activePannelId !== 0) {
      setExpandedState(true);
    } else {
      setExpandedState(false);
    }
  }, [activePannelId, setExpandedState]);

  useEffect(() => {
    if (putError) {
      setMessage(putError?.data?.message);
      setIssues(putError?.data?.issues);
    } else if (postError) {
      setMessage(postError?.data?.message);
      setIssues(postError?.data?.issues);
    } else {
      setMessage(success);
      setIssues(null);
    }
  }, [putError, postError, success]);

  const basicInformation = 'app.transaction.basicInformation';
  const editIcon = 'app.icon.edit';
  const dealStep = 'app.transaction.dealStep';
  const coefficient = 'app.transaction.coefficient';
  const priceMWh = 'app.transaction.priceMWh';
  const volumeMwh = 'app.transaction.volumeMWh';

  return (
    <>
      {(loading || putLoading || postLoading) && (
        <LoadingWrapper>
          <LoadingIndicator />
        </LoadingWrapper>
      )}
      <CustomExpansionPanel
        id={1}
        text={{ title: basicInformation, icon: editIcon }}
        active={activePannelId === 1}
        handler={changePannel}
        isNew={isNew}
        setIsNew={setIsNew}
        editable={editable}
        setEditable={setEditable}
        expandedState={expandedState}>
        <BasicInformation
          idPanel={2}
          transaction={transaction}
          handlers={handlers}
          isNew={isNew}
          handler={changePannel}
          editable={editable}
          setEditable={setEditable}
          setOpen={setOpen}
          loading={loaders}
        />
      </CustomExpansionPanel>

      <CustomExpansionPanel
        id={2}
        text={{ title: dealStep, icon: editIcon }}
        active={activePannelId === 2}
        handler={changePannel}
        isNew={isNew}
        setIsNew={setIsNew}
        editable={editable}
        setEditable={setEditable}
        expandedState={expandedState}>
        <PurchaseStep
          idPanel={3}
          transaction={transaction}
          handlers={handlers}
          enums={enums}
          isNew={isNew}
          handler={changePannel}
          editable={editable}
          setEditable={setEditable}
          setOpen={setOpen}
        />
      </CustomExpansionPanel>

      <CustomExpansionPanel
        id={3}
        text={{ title: coefficient, icon: editIcon }}
        active={activePannelId === 3}
        handler={changePannel}
        isNew={isNew}
        setIsNew={setIsNew}
        editable={editable}
        setEditable={setEditable}
        expandedState={expandedState}>
        <PriceCoefficient
          idPanel={4}
          currentHandler={handlers?.setIndexValues}
          currentValues={transaction?.indexValues}
          setPurchaseIndexTypeId={handlers?.setPurchaseIndexTypeId}
          purchaseIndexTypeId={transaction?.purchaseIndexTypeId}
          title={'Koeficient Tarif'}
          handlers={handlers}
          enums={enums}
          isNew={isNew}
          handler={changePannel}
          editable={editable}
          setEditable={setEditable}
          setOpen={setOpen}
          loaders={loaders}
        />
      </CustomExpansionPanel>

      <CustomExpansionPanel
        id={4}
        text={{ title: priceMWh, icon: editIcon }}
        active={activePannelId === 4}
        handler={changePannel}
        isNew={isNew}
        setIsNew={setIsNew}
        editable={editable}
        setEditable={setEditable}
        expandedState={expandedState}>
        <PriceCoefficient
          idPanel={5}
          currentHandler={handlers?.setTariffPrices}
          currentValues={transaction?.tariffPrices}
          title={'Tarrif'}
          handlers={handlers}
          isNew={isNew}
          handler={changePannel}
          editable={editable}
          setEditable={setEditable}
          setOpen={setOpen}
          loaders={loaders}
        />
      </CustomExpansionPanel>

      <CustomExpansionPanel
        id={5}
        text={{ title: volumeMwh, icon: editIcon }}
        active={activePannelId === 5}
        handler={changePannel}
        isNew={isNew}
        setIsNew={setIsNew}
        editable={editable}
        setEditable={setEditable}
        expandedState={expandedState}>
        <Volume
          transaction={transaction}
          handlers={handlers}
          isNew={isNew}
          handler={changePannel}
          editable={editable}
          setEditable={setEditable}
          setOpen={setOpen}
        />
      </CustomExpansionPanel>
      {!postLoading && !putLoading && message && (
        <CustomSnackBar status={putError || postError ? 'error' : 'success'} message={message} setOpen={setOpen} open={open} />
      )}
      {!postLoading &&
        !putLoading &&
        issues &&
        issues.map((issue) => <CustomSnackBar key={issue} status={'error'} message={issue} setOpen={setOpen} open={open} />)}
    </>
  );
};

TransactionBody.propTypes = {
  isNew: PropTypes.any,
  error: PropTypes.any,
  loading: PropTypes.any,
  transaction: PropTypes.object,
  handlers: PropTypes.object,
};

export default TransactionWrapper;
